import "./AssessDone.scss";
import React from "react";
import { withRouter } from "react-router";
import { authStore, resultStore, assessStore } from "../stores";
import InviteLink from "../dash/InviteLink";
import { Background, Button } from "../lib";
import background from "../assets/end-assess-bkg.png";
import { Link } from "react-router-dom";

const AssessDone = ({ match }) => {
  return (
    <div className="AssessDone">
      <Background src={background} />
      <div className="AssessDone_wrapper">
        <h1>You've already taken the assessment.</h1>
        {resultStore.churchResponse && <InviteLink />}
        <Button
          styleType="primary"
          to={resultStore.churchResponse ? "/dashboard" : "/results"}
        >
          View my results
        </Button>
        {(match && match.params && match.params.type === "team") ||
        resultStore.churchData ? (
          <Button
            onClick={() => {
              resultStore.takeAgain();
            }}
          >
            Clear data and take team assessment
          </Button>
        ) : (
          <Button
            onClick={() => {
              resultStore.reset();
              window.location.reload();
            }}
          >
            Clear data and take assessment again
          </Button>
        )}
      </div>
    </div>
  );
};

AssessDone.displayName = "AssessDone";

export default withRouter(AssessDone);



// WEBPACK FOOTER //
// ./src/assess/AssessDone.js